import axios from 'axios';
import {createBrowserHistory} from 'history';

/**
 *
 * @param url
 * @param data
 * @param method
 * @param params
 * @param options
 * @param clientConfig
 * @return {Promise<AxiosResponse<any>>}
 */
export async function api({
  url,
  data = {},
  method = 'GET',
  params = {},
  options = {},
  clientConfig = {
    timeout: 60000
  }
}) {
  const client = axios.create(clientConfig);
  return client
    .request({
      ...options,
      headers: {
        accept: 'application/json',
        ...(options.headers || {})
      },
      url,
      method,
      data,
      params
    })
    .then(res => res.data);
}

export const history = createBrowserHistory();
